/**
 * World catalog. Manifests are imported eagerly (small, needed for the gallery); world code is
 * loaded on demand. Development fixtures appear only when developer tools are enabled.
 */
import type { WorldModule } from '../framework/world/contract';
import type { WorldManifest } from '../framework/world/manifest';
import { MOSSLIGHT_MANIFEST } from './mosslight/manifest';
import { TEMPLATE_MANIFEST } from './_template/manifest';

export interface CatalogEntry {
  manifest: WorldManifest;
  load: () => Promise<WorldModule>;
}

export const catalog: CatalogEntry[] = [
  { manifest: MOSSLIGHT_MANIFEST, load: () => import('./mosslight').then((m) => m.default) },
  { manifest: TEMPLATE_MANIFEST, load: () => import('./_template').then((m) => m.default) },
];
